export default __webpack_public_path__ + "static/media/33.21e49cf3.png";